// lib/safeFileName.ts
export const safeFileName = (value: string, fallback = 'fater_export'): string =>
  value
    .trim()
    .replace(/[\\/*?:"<>|]/g, '_')
    .replace(/\s+/g, '_')
    .slice(0, 120) || fallback;
